import { render, staticRenderFns } from "./simpleCard.vue?vue&type=template&id=1ef2f69c&scoped=true&"
import script from "./simpleCard.vue?vue&type=script&lang=js&"
export * from "./simpleCard.vue?vue&type=script&lang=js&"
import style0 from "./simpleCard.vue?vue&type=style&index=0&id=1ef2f69c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef2f69c",
  null
  
)

export default component.exports